export const SAVE_TO_ARCHIVE = 'archive/SAVE_TO_ARCHIVE';
export const REMOVE_FROM_ARCHIVE = 'archive/REMOVE_FROM_ARCHIVE';
export const GET_AND_DELETE_FROM_ARCHIVE = 'archive/GET_AND_DELETE_FROM_ARCHIVE';
